import { Component, Input } from '@angular/core';
import { TemplateField } from 'src/app/core/models';

@Component({
  selector: 'app-field-renderer',
  templateUrl: './field-renderer.component.html',
  styleUrls: ['./field-renderer.component.scss']
})
export class FieldRendererComponent {
  @Input() field!: TemplateField;
  @Input() readonly = false;
  @Input() showValidation = false;

  get isEmpty(): boolean {
    const value = this.field.defaultValue;
    return value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0);
  }

  get isInvalid(): boolean {
    return this.showValidation && this.field.mandatory && this.isEmpty;
  }

  get hasOtherSelected(): boolean {
    if (!this.hasOtherOption) return false;
    const value = this.field.defaultValue;
    if (Array.isArray(value)) {
      return value.some((v) => (v ?? '').toString().toLowerCase() === 'other');
    }
    return (value ?? '').toString().toLowerCase() === 'other';
  }

  get hasOtherOption(): boolean {
    return this.field.options?.some((opt) => opt.toLowerCase() === 'other') ?? false;
  }

  get selectedValues(): string[] {
    return Array.isArray(this.field.defaultValue) ? this.field.defaultValue : [];
  }

  toggleMultiValue(option: string): void {
    if (this.readonly) return;
    const current = this.selectedValues;
    this.field.defaultValue = current.includes(option) ? current.filter((v) => v !== option) : [...current, option];
  }

  isChecked(option: string): boolean {
    return this.selectedValues.includes(option);
  }

  get activeConditionalGroups(): TemplateField[][] {
    if (!this.field.conditionalFields) return [];
    const selected = Array.isArray(this.field.defaultValue) ? this.field.defaultValue : [this.field.defaultValue];
    return selected
      .filter((value) => value && this.field.conditionalFields[value])
      .map((value) => this.field.conditionalFields[value]);
  }
}
